<template>
  <span>
    <v-btn
      color="primary"
      v-on:click="() => generalButton.eventFunction()"
      :loading="loading"
      :disabled="disabled"
    >
      <v-icon left>{{ generalButton.icon }}</v-icon>
      {{ $t(generalButton.text) }}
    </v-btn>
    <v-menu v-if="!menuHide || menuItems.length === 0" offset-y open-on-click>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="primary">
          <v-icon>
            mdi-chevron-down
          </v-icon>
        </v-btn>
      </template>
      <v-btn
        v-for="item in menuItems"
        block
        color="primary"
        v-on:click="() => item.eventFunction()"
        :loading="loading"
        v-bind:key="item.text"
        :disabled="disabled"
      >
        <v-icon left>{{ item.icon }}</v-icon>
        {{ $t(item.text) }}
      </v-btn>
    </v-menu>
  </span>
</template>

<script>
export default {
  name: "ButtonWithMenu",
  props: {
    menuHide: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    generalButton: {
      type: Object,
      default: () => ({
        icon: "",
        text: "",
        eventFunction: () => {}
      })
    },
    menuItems: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped></style>
